import { Route } from 'react-router-dom';
import { AdminModule } from '@/modules/admin';
import { BillingModule } from '@/modules/billing';
import { CalendarModule } from '@/modules/calendar';
import { CommercialModule } from '@/modules/commercial';
import { InventoryModule } from '@/modules/inventory';
import { LogisticsModule } from '@/modules/logistics';
import { MaintenanceModule } from '@/modules/maintenance';
import { ReservationsModule } from '@/modules/reservations';
import { modulePaths } from '@/routes/paths';
import { RequireModuleAccess } from '@/shared/components/RequireModuleAccess';

/**
 * Rutas de módulos de negocio con control de acceso por rol.
 */
export const moduleRoutes = (
  <>
    <Route
      path={`${modulePaths.inventory}/*`}
      element={
        <RequireModuleAccess moduleId="inventory">
          <InventoryModule />
        </RequireModuleAccess>
      }
    />
    <Route
      path={`${modulePaths.commercial}/*`}
      element={
        <RequireModuleAccess moduleId="commercial">
          <CommercialModule />
        </RequireModuleAccess>
      }
    />
    <Route
      path={`${modulePaths.reservations}/*`}
      element={
        <RequireModuleAccess moduleId="reservations">
          <ReservationsModule />
        </RequireModuleAccess>
      }
    />
    <Route
      path={`${modulePaths.billing}/*`}
      element={
        <RequireModuleAccess moduleId="billing">
          <BillingModule />
        </RequireModuleAccess>
      }
    />
    <Route
      path={`${modulePaths.logistics}/*`}
      element={
        <RequireModuleAccess moduleId="logistics">
          <LogisticsModule />
        </RequireModuleAccess>
      }
    />
    <Route
      path={`${modulePaths.maintenance}/*`}
      element={
        <RequireModuleAccess moduleId="maintenance">
          <MaintenanceModule />
        </RequireModuleAccess>
      }
    />
    <Route
      path={`${modulePaths.calendar}/*`}
      element={
        <RequireModuleAccess moduleId="calendar">
          <CalendarModule />
        </RequireModuleAccess>
      }
    />
    <Route
      path={`${modulePaths.admin}/*`}
      element={
        <RequireModuleAccess moduleId="admin">
          <AdminModule />
        </RequireModuleAccess>
      }
    />
  </>
);
